import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { userService } from "../../../_services";
import EditSheet from "./EditSheet";
import PricingSheetCard from "./PricingSheetCard";

function PricingSheetModule() {
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [pricingSheetData, setPricingSheetData] = useState([]);
    const [sheetEditData, setSheetEditData] = useState('');

    const getPricingSheets = (UserId) => {
        try {
            userService.FetchPricingSheets(UserId).then(apiData => {
                if (apiData && apiData.length > 0) {
                    setPricingSheetData(apiData);
                }
            }).catch(err => console.error('Error fetching pricing sheets:', err));
        } catch (err) {
            console.error('Error in getPricingSheets:', err);
        }
    };

    useEffect(() => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        getPricingSheets(Usermeta_Data.split(':')[0]);
    }, []);

    const changeInSheet = () => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        getPricingSheets(Usermeta_Data.split(':')[0]);
    };

    return (
        <>
            <Card className="border-border bg-card">
                <CardHeader className="border-b border-border px-6 py-3">
                    <h3 className="text-lg font-semibold text-primary">Pricing Sheets</h3>
                </CardHeader>
                <CardContent className="pt-6">
                    {pricingSheetData && pricingSheetData.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 xl:grid-cols-3 gap-4">
                            {pricingSheetData.map((item, index) => (
                                <PricingSheetCard
                                    key={index}
                                    sheetData={item}
                                    editSheet={() => { setSheetEditData(item); setShowEditPopup(true); }}
                                />
                            ))}
                        </div>
                    ) : (
                        <p className="text-center text-muted-foreground py-8">No pricing sheets available</p>
                    )}
                </CardContent>
            </Card>

            {showEditPopup && (
                <EditSheet
                    sheetData={sheetEditData}
                    hideModal={() => { setSheetEditData(''); setShowEditPopup(false); }}
                    changeInSheet={changeInSheet}
                />
            )}
        </>
    );
}

export default PricingSheetModule;

